export const manifest = {
  screens: {
    scr_snsmir: { name: "Portada (Hero)", route: "/#hero", position: {"x":160,"y":220} },
    scr_q5wgpy: { name: "Urgencia y Oferta", route: "/#oferta", position: {"x":1560,"y":220} },
    scr_8upphn: { name: "Bonos Exclusivos", route: "/#bonos", position: {"x":2960,"y":220} },
    scr_kq6kub: { name: "Sección de Compra", route: "/#compra", position: {"x":4360,"y":220} },
    scr_hrxlqn: { name: "Comunidad y Reseñas", route: "/#comunidad", position: {"x":5760,"y":220} },
  },
  sections: {
    sec_3cb5sz: { name: "Landing page funnel", x: 0, y: 0, width: 7120, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_3cb5sz", children: [
      { kind: "screen", id: "scr_snsmir" },
      { kind: "screen", id: "scr_q5wgpy" },
      { kind: "screen", id: "scr_8upphn" },
      { kind: "screen", id: "scr_kq6kub" },
      { kind: "screen", id: "scr_hrxlqn" },
    ] },
  ],
}
